module.exports = __webpack_public_path__ + "img/pimg12.c6b614e0.png";